import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';
import CarrierGroupDetail from '@app/pages/customer/carriergroups/CarrierGroupDetail.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const CarrierGroupDetailPage = () => {
  const { id } = useParams();

  const { t } = useTranslation('common');

  return (
    <>
      {id && (
        <ResponsiveLayout title={t(`CarrierGroup.title`, `Detail skupiny`)} oneOfPermission={[PermissionTypesEnum.PERMISSION_MY_CARRIERS, PermissionTypesEnum.PERMISSION_CARRIER_GROUP_READ, PermissionTypesEnum.PERMISSION_CARRIER_GROUP_RW]}>
          <CarrierGroupDetail carrierGroupId={id as string} />
        </ResponsiveLayout>
      )}
    </>
  );
};

export default withAuthenticationRequired(CarrierGroupDetailPage);
